/* PictureBlock - migrated to Tailwind */
import { contentBlockClassName } from '../../ContentBlockStyles';

export const pictureBlockClassName = `${contentBlockClassName} flex items-center flex-col [&_h3]:self-start [&_h3]:text-black [&_h3]:font-serif [&_h3] [&_h3]:font-normal [&_h3]:text-2xl [&_h3]:leading-[26px] [&_h3]:mb-10 [&_img]:max-w-full`;
